import { State } from 'src/types'
import { edgeForNormalPocket, edgeForShallowPocket } from './edge'

export const edgeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color

  const isShallowWebModel = ['AKG-JS2'].includes(state.baseModel.productNumber)
  if (isShallowWebModel) {
    edgeForShallowPocket(ctx, state.edge.color)
  }

  if (!isShallowWebModel) {
    edgeForNormalPocket(ctx, state.edge.color)
  }
}
